import './Hero.css';
import Carousel from 'react-material-ui-carousel';
import { Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LoaderComp from '../loadercomp/LoaderComp';
import zIndex from '@mui/material/styles/zIndex';


const Hero = ({movies}) => {
    const navigate = useNavigate();

    function reviews(moveId) {
        navigate(`/Reviews/${moveId}`)
    }

    return (
        <div className='movie-carousel-container'>
            <Carousel>
                {
    
                    movies !== undefined ?   movies?.map((movie) => {
                        return (
                            <Paper key={movie.imdbId}>
                                <div className='movie-card-container'>
                                    {/* The variable "--img" can be use at the hero.css, check hero.css to see how it was used */}
                                    <div className='movie-card' style={{"--img": `url(${movie.backdrops[0]})`}}>
                                        <div className='movie-detail'>
                                            <div className='movie-poster'>
                                                <img src={ movie.poster } alt='' />
                                            </div>
                                            <div className='movie-title'>
                                                <h4>{ movie.title }</h4>
                                            </div>
                                            <div className="movie-buttons-container">
                                                <Link to={ `/Trailer/${movie.trailerLink.substring(movie.trailerLink.length - 11) } `}>
                                                    <div className='play-button-icon-container'>
                                                        <FontAwesomeIcon className='play-button-icon' icon={faCirclePlay}/>
                                                    </div>
                                                </Link>

                                                <div className='movie-review-button-container'>
                                                    <Button variant='info' onClick={() => reviews(movie.imdbId)}> Reviews </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Paper>
                        )
                    }) : (
                        <div style={{ 
                            display: "flex", 
                            justifyContent: "center", 
                            alignContent: "center",
                            marginTop: "10px"}}>
                            <LoaderComp/>
                        </div>
                    )
                }
            </Carousel>
        </div>
    )
}

export default Hero;